import React from "react";
import "../../../css/buttons/TertiaryButton.css";

const TertiaryButton = ({
  onClick,
  text,
  type = "button",
  className = "",
  ...buttonProps
}) => {
  const handleClick =
    onClick ||
    (() => {
      const label = text?.toLowerCase() || "";

      if (label.includes("read faqs")) {
        document
          .querySelector("#faqs, [data-section='faqs']")
          ?.scrollIntoView({ behavior: "smooth" });
      }
    });

  return (
    <button
      type={type}
      className={`tertiary-button ${className}`.trim()}
      onClick={handleClick}
      {...buttonProps}
    >
      <div className="button-text">{text}</div>
    </button>
  );
};

export default TertiaryButton;
